export default function SingleCard({
    cardData,
    icons,
    index,
    iniHiddenCards,
    loadMoreVals,
}) {
    let event_time, hiddenClass;

    const imgSizes =
        "(max-width: 560px) 80vw, (max-width: 992px ) 50vw, (max-width: 1400px ) 35vw, 35vw";

    const clickImageHandler = (e) => {
        e.preventDefault();

        let image = e.currentTarget;
        if (image && image.dataset.cardUrl) {
            window.location.assign(image.dataset.cardUrl);
        }
    };

    function hideCardsOnInitialLoad() {
        if (iniHiddenCards.includes(cardData.post_id)) {
            hiddenClass = "hidden-card";
        } else {
            hiddenClass = "";
        }
    }

    function showCardsAfterLoadMore() {
        if (
            loadMoreVals.chunk.includes(cardData.post_id) ||
            loadMoreVals.displayed.includes(cardData.post_id)
        ) {
            // Show card.
            hiddenClass = "";
        } else {
            // Keep hidden for now.
            hiddenClass = "hidden-card";
        }
    }

    // Conditionals
    if (cardData.instances?.length === 1) {
        event_time = ", " + cardData.time;
    } else {
        event_time = "";
    }

    // Handle display of cards. Driven by Show more btn.
    if (loadMoreVals.pageNum == 1) {
        hideCardsOnInitialLoad();
    } else if (loadMoreVals.pageNum > 1) {
        showCardsAfterLoadMore();
    }

    let eventLocation = cardData.overriden_location
        ? cardData.overriden_location
        : cardData.full_location;

    // Render JSX.
    return (
        <article
            className={`card card--event not-prose ${hiddenClass}`}
            data-card-url={cardData.url}
            role="group"
            key={index}
        >
            {/**  Image */}
            {cardData.image?.src ? (
                <div className="card__image" onClick={clickImageHandler}>
                    <div className="card__image-inner img-fit">
                        <img
                            src={cardData.image.src}
                            className="attachment-original_crop@1440 size-original_crop@1440"
                            alt={cardData.image.alt}
                            decoding="async"
                            loading="lazy"
                            srcSet={cardData.image.srcset}
                            sizes={imgSizes}
                        />
                    </div>
                </div>
            ) : null}

            <div className="card__content stack stack--s ">
                {/**  location */}
                {eventLocation && (
                    <p className="card__location">
                        <span className="card__location--icon">
                            {icons.event_location}
                        </span>
                        {eventLocation}
                    </p>
                )}

                {/** Event name */}
                {cardData.name && (
                    <h4
                        className="card__heading"
                        dangerouslySetInnerHTML={{ __html: cardData.name }}
                    />
                )}

                {cardData.date_range && (
                    <p
                        className="card__date"
                        aria-label="Dates"
                        dangerouslySetInnerHTML={{
                            __html: cardData.date_range + event_time,
                        }}
                    />
                )}

                {/**  Full summary */}
                {cardData.summary && (
                    <div
                        className="card__summary"
                        dangerouslySetInnerHTML={{ __html: cardData.summary }}
                    />
                )}

                <div className="card__actions">
                    {cardData.booking_btn?.link ? (
                        <a
                            href={cardData.booking_btn.link}
                            className={`btn btn--secondary-large ${cardData.event_status.current}`}
                            aria-label={
                                cardData.event_status == "available"
                                    ? `Book now for ${card.name}`
                                    : ``
                            }
                        >
                            {cardData.booking_btn.label}
                            <span className="sr-text">Book now</span>
                        </a>
                    ) : null}

                    {cardData.url ? (
                        <a
                            href={cardData.url}
                            className="card__fill-link btn btn-event"
                        >
                            Find out more
                        </a>
                    ) : null}
                </div>
            </div>
        </article>
    );
}
